<template>
  <v-container fluid class="text-center">
    <Loader :loading="loading" />
    <Table-Container title="Solicitudes" :exportInfo="items">
      <template v-slot:buttons>
        <Basic-Btn text="Agregar" color="primary" icon="mdi-plus" @click="dialogs.new = true" :loading="loading" />
        <Basic-Btn text="Actualizar" color="success" icon="mdi-refresh" @click="refresh()" :loading="loading" />
      </template>
      <template v-slot:search>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
      </template>
      <v-data-table :headers="headers" :items="items" :loading="loading" :search="search" :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:[`item.usuario.detalles_usuarios[0].nombre`]="{ item }">
          {{ item.usuario && item.usuario.detalles_usuarios.length > 0 ? item.usuario.detalles_usuarios[0].nombre + " " + item.usuario.detalles_usuarios[0].apellido_paterno + " " + item.usuario.detalles_usuarios[0].apellido_materno : "Empleado sin asignar" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left
            ><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="primary" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item)">mdi-pencil</v-icon></template
            ><span>Editar</span></v-tooltip
          >
          <v-tooltip right
            ><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="error" dark v-bind="attrs" v-on="on" :disabled="loading" @click="remove(item.idsolicitud_calendario)">mdi-delete</v-icon></template
            ><span>Eliminar</span></v-tooltip
          >
        </template>
        <template v-slot:[`footer.page-text`]="props"> Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }} </template>
        <template v-slot:no-data> No hay información disponible </template>
        <template v-slot:no-results> No se obtuvieron resultados </template>
      </v-data-table>
    </Table-Container>

    <Dialog-Form :estate="dialogs.new" title="Nueva solicitud">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="error" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn text="Guardar" color="success" icon="mdi-check" @click="save()" :loading="loading" />
      </template>
      <v-form ref="formNew" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-autocomplete v-model="forms.new.usuario" :items="users" item-text="nombreCompleto" item-value="idusuario" label="Empleado" prepend-icon="mdi-account" persistent-hint no-data-text="No se encontraron resultados" dense outlined></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="forms.new.tipo_solicitud" :items="requestType" item-text="nombre" item-value="idtipo_solicitud" label="Tipo de solicitud" prepend-icon="mdi-calendar-alert" persistent-hint no-data-text="No se encontraron resultados" dense outlined></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <Date-Picker v-model="forms.new.fecha_inicio" label="Fecha inicio" offYear offLimit/>
          </v-col>
          <v-col cols="6">
            <Date-Picker v-model="forms.new.fecha_fin" label="Fecha fin" offYear offLimit/>
          </v-col>
        </v-row>
      </v-form>
    </Dialog-Form>
    <Dialog-Form :estate="dialogs.update" title="Actualizar solicitud">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="error" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn text="Actualizar" color="success" icon="mdi-check" @click="update()" :loading="loading" />
      </template>
      <v-form ref="formUpdate" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-autocomplete v-model="forms.update.usuario" :items="users" item-text="nombreCompleto" item-value="idusuario" label="Empleado" prepend-icon="mdi-account" persistent-hint no-data-text="No se encontraron resultados" dense outlined></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="forms.update.tipo_solicitud" :items="requestType" item-text="nombre" item-value="idtipo_solicitud" label="Tipo de solicitud" prepend-icon="mdi-calendar-alert" persistent-hint no-data-text="No se encontraron resultados" dense outlined></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <Date-Picker v-model="forms.update.fecha_inicio" label="Fecha inicio" offYear offLimit/>
          </v-col>
          <v-col cols="6">
            <Date-Picker v-model="forms.update.fecha_fin" label="Fecha fin" offYear offLimit/>
          </v-col>
        </v-row>
      </v-form>
    </Dialog-Form>

    <Delete-Message :estate="dialogs.remove" msg="¿Realmente desea eliminar la solicitud?">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="disabled" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn text="Eliminar" color="error" icon="mdi-check" @click="remove()" :loading="loading" />
      </template>
    </Delete-Message>
    <BasicAlert :active.sync="alert.active" :msg="alert.msg" :color="alert.color" />
  </v-container>
</template>

<script>
import services from "@/utils/services";
import { Loader, DialogForm, BasicAlert, TableContainer, BasicBtn, DeleteMessage, DatePicker } from "@/components";

export default {
  name: "request-calendar",
  components: {
    Loader,
    DialogForm,
    BasicAlert,
    TableContainer,
    BasicBtn,
    DeleteMessage,
    DatePicker,
  },
  data: () => ({
    loading: false,
    alert: {
      active: false,
      color: "error",
      msg: "",
    },
    search: "",
    headers: [
      { text: "ID", align: "left", sortable: true, value: "idsolicitud_calendario" },
      { text: "Empleado", align: "left", sortable: true, value: "usuario.detalles_usuarios[0].nombre" },
      { text: "Tipo de solicitud", align: "left", sortable: true, value: "tipo_solicitud.nombre" },
      { text: "Fecha inicio", align: "left", sortable: true, value: "fecha_inicio" },
      { text: "Fecha fin", align: "left", sortable: true, value: "fecha_fin" },
      { text: "Acciones", align: "left", sortable: false, value: "actions" },
    ],
    items: [],
    users: [],
    requestType: [],
    deleted: null,
    forms: {
      new: {
        idsolicitud_calendario: "",
        usuario: "",
        tipo_solicitud: "",
        fecha_inicio: "",
        fecha_fin: "",
      },
      update: {
        idsolicitud_calendario: "",
        usuario: "",
        tipo_solicitud: "",
        fecha_inicio: "",
        fecha_fin: "",
      },
    },
    rules: {
      nombre: [(v) => !!v || "El campo es requerido", (v) => (v && v.length <= 100) || "El campo excede la longitud máxima"],
    },
    dialogs: {
      new: false,
      update: false,
      remove: false,
    },
  }),
  mounted() {
    this.refresh();
    this.getRequestType();
    this.getUser();
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.axios
        .get(services.routes.requestCalendar)
        .then((response) => {
          this.items = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getRequestType() {
      this.loading = true;
      this.axios
        .get(services.routes.requestType)
        .then((response) => {
          this.requestType = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getUser() {
      this.loading = true;
      this.axios
        .get(services.routes.user)
        .then((response) => {
          this.users = response.data.data;
          for (let i = 0; i < this.users.length; i++) {
            this.users[i].nombreCompleto =
              (this.users[i].detalles_usuarios[0].no_empleado ? this.users[i].detalles_usuarios[0].no_empleado : "") +
              (this.users[i].detalles_usuarios[0].nombre ? " " + this.users[i].detalles_usuarios[0].nombre : "") +
              (this.users[i].detalles_usuarios[0].apellido_paterno ? " " + this.users[i].detalles_usuarios[0].apellido_paterno : "") +
              (this.users[i].detalles_usuarios[0].apellido_materno ? " " + this.users[i].detalles_usuarios[0].apellido_materno : "");
          }
        })
        .catch((error) => {
          this.alert.active = true;
          this.alert.color = "error";
          this.alert.msg = error.response.data.message || "Servicio no disponible";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      if (this.dialogs.new) {
        this.$refs.formNew.reset();
        for (let key in this.forms.new) {
          this.forms.new[key] = "";
        }
        this.dialogs.new = false;
      } else if (this.dialogs.update) {
        this.dialogs.update = false;
      } else if (this.dialogs.remove) {
        this.dialogs.remove = false;
      }
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.forms.new));
        this.axios
          .post(services.routes.requestCalendar, { data })
          .then((response) => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Solicitud creada exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "La información es incorrecta";
      }
    },
    view(data) {
      this.forms.update = JSON.parse(JSON.stringify(data));
      this.forms.update.tipo_solicitud=  this.forms.update.tipo_solicitud ? this.forms.update.tipo_solicitud.idtipo_solicitud : 0
      this.forms.update.usuario=  this.forms.update.usuario.idusuario
      this.dialogs.update = true;
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.forms.update));
        this.axios
          .put(services.routes.requestCalendar, { data })
          .then((response) => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Solicitud actualizada exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "La información es incorrecta";
      }
    },
    remove(id) {
      if (!id) {
        this.loading = true;
        this.axios
          .delete(services.routes.requestCalendar, { data: { data: { idsolicitud_calendario: this.deleted } } })
          .then((response) => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Solicitud eliminada exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.deleted = id;
        this.dialogs.remove = true;
      }
    },
  },
};
</script>

<style scoped></style>
